<div class="Customers customer-company ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ this.titlePage | translate}} <span *ngIf="basicInfo"> - {{ basicInfo.customerCode }}</span></h1>
  </div>

  <div class="ui-g-12 ui-lg-6 text-right">
    <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-angle-left"
    iconPos="left"
    (click)="confirm()" label="{{ 'common.back' | translate }}"></button>
    <button
    pButton
    (click)="checkCustomerLogin()"
    type="button"
    class="k-generic-btn"
    icon="fa fa-floppy-o"
    iconPos="left"
    label="{{ 'common.save' | translate }}"></button>
    <!--<button
    *ngIf="customerMgPermission"
    pButton
    (click)="saveMg()"
    type="button"
    class="k-generic-btn"
    icon="fa fa-floppy-o"
    iconPos="left"
    label="{{ 'common.save' | translate }}"></button>-->
  </div>

  <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

  <div class="customer-container card ui-g-nopad" *ngIf="!customerMgPermission">
    <app-customer-company-basic
      *ngIf="show.basic"
      [validationForm]="validationForm"
      [hidden]="activeIndex !== 0"
      [editMode]="editMode"
      [customerId]="customerId"
      (basicInfoLoaded)="basicInfoLoaded($event)"
      (myCustomerCodeLoaded)="myCustomerCodeLoaded($event)"
      (dirtyFormData)="checkFormData($event)"
    ></app-customer-company-basic>
    <app-customer-company-address
      [hidden]="activeIndex !== 1"
      [customerId]="customerId"
      *ngIf="editMode"
      (dirtyFormData)="checkFormData($event)"
    ></app-customer-company-address>
    <kv-customer-loyaltyinfo
      [hidden]="activeIndex !== 2"
      *ngIf="editMode && show.loyaltyInfo && show.permissions"
      [customerId]="customerId"
      [basicInfo]="basicInfo"
      [cards]="cards"
      [customerPermissions]="customerPermissions"
      [loyaltyPermissions]="loyaltyPermissions"
      (noCardLinked)="noCardLinked()"
      (domiciliationDone)="domiciliationDone()"
      (cardAddDone)="cardAddDone()"
      (cardSubstitutionDone)="cardSubstitutionDone()"
      (cardBlacklistDone)="cardBlacklistDone()"
    ></kv-customer-loyaltyinfo>
    <app-customer-clusters
      [hidden]="activeIndex !== 3"
      *ngIf="editMode && show.permissions"
      [customerId]="customerId"
      [basicInfo]="basicInfo"
      [myCustomerCode]="myCustomerCode"
      [mgCustomerPermission]="customerMgPermission"
      (clusterChanged)="clusterChangedHandler($event)"
      (clusterListChanged)="clusterListChangedHandler($event)"
      [kloyCustomerPermission]="customerKloyPermission"
      [cards]="cards"
    ></app-customer-clusters>
    <app-upload-mg-company
      [hidden]="activeIndex !== 4"
      *ngIf="editMode && show.uploadModule && basicInfo && companyInfo && cardInfo"
      [customerHostId]="customerId"
      [basicInfo]="basicInfo"
      [companyInfo]="companyInfo"
    ></app-upload-mg-company>
    <app-coupon-manager
      *ngIf="couponManagerPermission && customer_id"
      [hidden]="activeIndex !== 5"
      [customerId]="customer_id"
      [couponTab]="activeIndex"
    ></app-coupon-manager>
  </div>


  <div class="customer-container card" *ngIf="customerMgPermission">
    <app-customer-company-basic-new
      *ngIf="show.basic"
      [hidden]="activeIndex !== 0"
      [editMode]="editMode"
      [customerId]="customerId"
      [cardInfo]="cards"
      (basicInfoLoaded)="basicInfoLoaded($event)"
      (companyInfoLoaded)="companyInfoLoaded($event)"
      (cardsInfoLoaded)="cardsInfoLoaded($event)"
      (dirtyFormData)="checkFormData($event)"
      (allMandatoryFieldsOkLoaded)="allMandatoryFieldsOkLoaded($event)"
    ></app-customer-company-basic-new>
    <kv-customer-loyaltyinfo
      [hidden]="activeIndex !== 1"
      *ngIf="editMode && show.loyaltyInfo"
      [customerId]="customerId"
      [basicInfo]="basicInfo"
      [cards]="cards"
      [customerPermissions]="customerPermissions"
      [loyaltyPermissions]="loyaltyPermissions"
      (domiciliationDone)="domiciliationDone()"
      (noCardLinked)="noCardLinked()"
      (cardAddDone)="cardAddDone()"
      (cardSubstitutionDone)="cardSubstitutionDone()"
      (cardBlacklistDone)="cardBlacklistDone()"
    ></kv-customer-loyaltyinfo>
    <app-customer-clusters
      [hidden]="activeIndex !== 2"
      *ngIf="editMode && show.permissions"
      [customerId]="customerId"
      [basicInfo]="basicInfo"
      [myCustomerCode]="myCustomerCode"
      [mgCustomerPermission]="customerMgPermission"
      (clusterChanged)="clusterChangedHandler($event)"
      (clusterListChanged)="clusterListChangedHandler($event)"
      [kloyCustomerPermission]="customerKloyPermission"
      [cards]="cards"
    ></app-customer-clusters>
    <app-upload-mg-company
      [hidden]="activeIndex !== 3"
      *ngIf="editMode && show.uploadModule && basicInfo && companyInfo && cardInfo"
      [customerHostId]="customerId"
      [basicInfo]="basicInfo"
      [companyInfo]="companyInfo"
      (customerHasFiles)="customerHasFiles = $event"
    ></app-upload-mg-company>
    <app-coupon-manager
      *ngIf="couponManagerPermission && customer_id"
      [hidden]="activeIndex !== 4"
      [customerId]="customer_id"
      [couponTab]="activeIndex"
    ></app-coupon-manager>
  </div>

  <p-confirmDialog key="confirm"></p-confirmDialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company.component.html